export const BRAND = {
  name: "MAISON DOUBA",
  email: "maisondouba@wwwmaisondouba.com",
  phone_display: "+33 6 41 85 31 60",
  phone_link: "+33641853160",
  whatsapp: "https://wa.me/message/RJHM4VGK4U3HB1",
  instagram: "https://www.instagram.com/maison_douba",
  tiktok: "https://www.tiktok.com/@wattisera",
  address_line1: "47 Boulevard du Moulin de la Tour",
  address_line2: "92350 Le Plessis-Robinson",
  address_country: "France",
};

// Informations légales officielles de l'entreprise
export const LEGAL = {
  company_name: "Wassa Shopping",
  trademark: "MAISON DOUBA",
  owner: "YATTE SACKO",
  legal_form: "Entrepreneur individuel",
  siren: "929 092 898",
  siret: "929 092 898 00014",
  ape_code: "47.91A",
  ape_label: "Vente à distance sur catalogue général",
  address: "47 Boulevard du Moulin de la Tour, 92350 Le Plessis-Robinson, France",
  contact_email: "maisondouba@wwwmaisondouba.com",
  contact_phone: "+33 6 41 85 31 60",
  tva_mention: "TVA non applicable, article 293 B du CGI",
};
